


import Parse from 'parse';


async function saveDroppedPlan({ lat, lng, planId, plansBySeries, presentationModeiFrame }) {

    try {

        const currentUser = Parse.User.current();

        if (!currentUser) {
            console.log('No logged-in user; not saving dropped plan.');
            return;
        }

        const firstName = currentUser.get('firstName') || '';
        const lastName = currentUser.get('lastName') || '';
        const nameOfUser = `${firstName} ${lastName}`.trim();

        const allPlans = Object.entries(plansBySeries).flatMap(([seriesName, plans]) =>
            plans.map(plan => ({ plan, seriesName }))
        );

        const found = allPlans.find(({ plan }) => plan.id === planId);

        if (!found) {
            console.warn('Plan not found in plansBySeries, cannot determine style.');
            return;
        }

        const planName = found.plan.get('name') || 'Unnamed Plan';
        const seriesName = found.seriesName;

        // Translate series name → style
        let style;
        switch (seriesName) {
            case 'Transportables':
                style = 'Transportables';
                break;
            case 'Fraemohs First':
            case 'Alpine':
            case 'TimberMode':
                style = 'TimberFramed';
                break;
            case 'Solid Timber':
                style = 'SolidTimber';
                break;
            case 'Accessory':
                style = 'Accessory';
                break;
            default:
                style = 'Unknown';
        }

        const DroppedPlan = Parse.Object.extend('DroppedPlansWithLocation');
        const droppedPlan = new DroppedPlan();

        droppedPlan.set('coordinates', `${lat.toFixed(6)}, ${lng.toFixed(6)}`);
        droppedPlan.set('nameOfUser', nameOfUser);
        droppedPlan.set('planName', planName);
        droppedPlan.set('style', style);
        droppedPlan.set('presentationModeiFrame', presentationModeiFrame);
        droppedPlan.set('clientType', 'web');

        await droppedPlan.save();

        //console.log('Dropped plan saved successfully.');
    }
    catch (error) {
        console.error('Error saving dropped plan:', error.message, error.code, error);
    }
}

export default saveDroppedPlan;


